import { observable, makeObservable, actionBound } from "mobx";
import type GlobalStore from "./index";
import { syncShopSubscription } from "@/services/api/shop";

/**
 * @todo
 * 当前订购记录、软件版本和到期时间相关的操作全部在全局store中，将所有相关操作集中到本文件中，实现统一管理
 */
class AppSubscriptionStore {
    constructor(private globalStore: typeof GlobalStore) {
        makeObservable(this, {
            syncShopSubScriptionLoadingMap: observable,
            syncShopSubscription: actionBound,
        });
    }

    syncShopSubScriptionLoadingMap = new Map<number, boolean>();

    async syncShopSubscription(shopId: number) {
        /** 抖店测试店铺，不需要同步 */
        if (shopId === 175712) return;

        this.syncShopSubScriptionLoadingMap.set(shopId, true);

        try {
            await syncShopSubscription(shopId);
        } finally {
            this.syncShopSubScriptionLoadingMap.set(shopId, false);
        }
    }
}

export default AppSubscriptionStore;
